module.exports = __webpack_public_path__ + "img/LayerDatenAufteilung.b5160f5f.png";